import React from "react";
import styles from "./RecentCatchCard.module.css";
import cn from 'classnames';
import { Card, Image } from "react-bootstrap";
import { ASSESTS } from "../../../constant/assest";

interface IProps {
    className?: string;
    featureImage: string;
    title: string;
    weight: string;
    length: string;
    location: string;
    date: string;
    weather: string;
};

const RecentCatchCard: React.FC<IProps> = ({
    className,
    featureImage,
    title,
    weight,
    length,
    location,
    date,
    weather,
}) => {

    const renderDataItem = (label: string, value: string) => {
        return (
            <Card.Footer bsPrefix={styles.recentCatchCardItem}>
                <Card.Text as={'div'} bsPrefix={styles.recentCatchLabel}>{label} :</Card.Text>
                <Card.Text as={'div'} bsPrefix={styles.recentCatchValue}>{value}</Card.Text>
            </Card.Footer>
        );
    };

    return (
        <Card bsPrefix={cn(styles.recentCatchCard, className)}>
            <Card.Header bsPrefix={styles.recentCatchCardHeader}>
                <Image
                    src={featureImage}
                    alt={title}
                    className={styles.recentCatchCardImg}
                    onError={(e) => {
                        e.currentTarget.onerror = null; // prevents infinite loop
                        e.currentTarget.src = ASSESTS.FISHINGDUMMY;
                    }}
                />               
            </Card.Header>
            <Card.Body bsPrefix={styles.recentCatchCardBody}>
                <Card.Title as={'div'} bsPrefix={styles.recentCatchTitle}>{title}</Card.Title>
                {renderDataItem('Weight', weight)}
                {renderDataItem('Length', length)}
                {renderDataItem('Location', location)}
                {renderDataItem('Date', date)}
                {renderDataItem('Weather', weather)}
            </Card.Body>
        </Card>
    );
};

export default RecentCatchCard;
